/**
 * Shared class set for the header user-actions row items (currency, stores, account, NDULGE, …).
 *
 * Every item shares identical typography, spacing, and hover — regardless of whether it renders as a
 * native button, a link, or a span — so the row reads as one consistent set of controls. The text
 * triggers intentionally use a plain `<button>` rather than the shadcn `Button`, whose opinionated
 * defaults (`font-medium`, fixed `h-9`, size padding) would make them diverge from the plain links.
 *
 * Per-item concerns are layered on by each item: visibility (`hidden lg:flex` for desktop-only items),
 * and `cursor-default` for the inert currency display. Horizontal spacing between items is owned by the
 * row container's `gap` (see `UserActions`), matching Figma — not per-item padding.
 */
export const USER_ACTION_ITEM_CLASSES =
    'relative flex items-center gap-2 text-sm uppercase whitespace-nowrap cursor-pointer transition-opacity hover:opacity-50';
